import { PaymentMethods } from '../../constants/PaymentTypes';

/**
 * If at least one payment button is enabled and credit card form is shown then returns true
 * to indicate that we should show an 'or' spacer.
 * @param buttonsFlags array of booleans indicating if a button is enabled or disabled
 * @param showCreditCard boolean indicating if we are showing the credit card form
 */
export function shouldShowDivider(buttonsFlags, showCreditCard) {
  return buttonsFlags.some(Boolean) && showCreditCard;
}

/**
 * Counts the total number of enabled third party payment buttons.
 * @param buttonFlags boolean array of third party buttons indicating if they are enabled or disabled.
 * @returns the count of enabled buttons
 */
export function countTotalShownButtons(buttonFlags) {
  return buttonFlags.filter(Boolean).length;
}

/**
 * Returns true if Venmo should be supported for US and config venmoVisible true
 * @param supportedPaymentMethods
 * @param venmoVisible
 * @param country
 * @returns boolean indicating if venmo should be enabled
 */
export var isVenmoEnabled = function isVenmoEnabled(supportedPaymentMethods, venmoVisible, country) {
  return venmoVisible && supportedPaymentMethods.includes(PaymentMethods.VENMO) && country === 'US';
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/PaymentButtons/helper.js
// module id = 1501
// module chunks = 11